"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadNetScalarGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrCadNetScalarGroupingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, _hierarchy) {
        const buckets = new Map();
        for (const group of manager.iterateGroups()) {
            for (const [instance, nets] of group.getNets()) {
                let byInstance = buckets.get(instance);
                if (!byInstance) {
                    byInstance = new Map();
                    buckets.set(instance, byInstance);
                }
                for (const net of nets) {
                    for (const wire of net.wires) {
                        const id = wire.strategyMetadata?.['net-scalar-id'];
                        if (id === undefined) {
                            continue;
                        }
                        let bucket = byInstance.get(id);
                        if (!bucket) {
                            bucket = new Set();
                            byInstance.set(id, bucket);
                        }
                        bucket.add(group);
                    }
                }
            }
        }
        for (const byInstance of buckets.values()) {
            for (const bucket of byInstance.values()) {
                if (bucket.size <= 1) {
                    continue;
                }
                manager.mergeGroups(...Array.from(bucket));
            }
        }
        return manager;
    }
}
exports.OrCadNetScalarGroupingRule = OrCadNetScalarGroupingRule;
//# sourceMappingURL=OrcadNetScalarGroupingRule.js.map